import moment from "moment";

export function compareStrings(a, b) {
    // Assuming you want case-insensitive comparison
    a = a.toLowerCase();
    b = b.toLowerCase();

    return (a < b) ? -1 : (a > b) ? 1 : 0;
}

export function isAuditor(currentUser) {
    if (currentUser) {
        let authorities = currentUser.authorities;
        for (let key of Object.keys(authorities)) {
            console.log(key, authorities[key].authority)
            if ("ROLE_AUDITOR" === authorities[key].authority) {
                console.log("Auditor")
                return true;
            } else {
                console.log("Not Auditor")
                return false;

            }
        }
    }
    return false;
}

export function expiredDateStyle(value) {
    let color = 'white';
    let textFontWeight = 'normal';
    console.log('value', value);
    if (value !== undefined && value !== '') {
        let nowInMilliseconds = moment().valueOf();
        let expiryInMilliseconds = moment(value, 'DD/MM/YYYY').valueOf();
        if (expiryInMilliseconds < nowInMilliseconds) {
            color = 'red';
            textFontWeight = 'bold';
        } else {
            color = 'black';
        }
    }
    return {
        color: color,
        fontWeight: textFontWeight,
    }
}

export function expiredDateStyleForMuiTable(value) {
    let color = 'white';
    let textFontWeight = 'normal';
    console.log('value', value);
    if (value !== undefined && value !== '') {
        let nowInMilliseconds = moment().valueOf();
        let expiryInMilliseconds = moment(value).valueOf();
        if (expiryInMilliseconds < nowInMilliseconds) {
            color = 'red';
            textFontWeight = 'bold';
        } else {
            color = 'black';
        }
    }
    return {
        color: color,
        fontWeight: textFontWeight,
    }
}